import { checkAccessToken } from '@/components/default/utils/auth';
// import StorageService from '../app/storage.service'
// import CookieService from '../app/cookie.service'
import authHeader from './auth-header';
import apiHeader from './noAuth-header';
import StorageService from '../app/storage.service';
import CookieService from '../app/cookie.service';

export const ApiInterceptionFetch = async (url, userOptions = {}, needsAuth = true, subscriberAuth = false) => {
    try {
        // const defaultHeaders = {
        //     'Content-Type': 'application/json',
        // };

        let defaultHeaders = {};
        // console.log('subscriberAuth', subscriberAuth);
        // console.log('needsAuth', needsAuth);
        // Add authentication logic only if `needsAuth` is true
        if (subscriberAuth) {
            // Ensure authentication is valid (refresh token if needed)
            const isAuthenticated = await checkAccessToken(false);

            if (!isAuthenticated) {
                // StorageService.clear()
                // CookieService.clear()

                // window.location.href = '/'

                throw new Error('Interception! You are not authenticated. Redirecting to home page...'); // Stop further execution
            }

            // Merge auth headers
            Object.assign(defaultHeaders, authHeader(false));
        } else if (needsAuth) {
            // Ensure authentication is valid (refresh token if needed)
            const isAuthenticated = await checkAccessToken();

            if (!isAuthenticated) {
                // StorageService.clear()
                // CookieService.clear()
                // console.log('Interception! You are not authenticated. Redirecting to home page');
                // window.location.href = '/'

                throw new Error('Interception! You are not authenticated. Redirecting to home page...'); // Stop further execution
            }

            // Merge auth headers
            Object.assign(defaultHeaders, authHeader());
        } else {
            // Merge auth headers
            Object.assign(defaultHeaders, apiHeader());
        }

        // Check if body is FormData
        const isFormData = userOptions.body instanceof FormData;

        // Only set Content-Type if not FormData
        if (!isFormData) {
            defaultHeaders['Content-Type'] = 'application/json';
        }

        // Merge user-provided options
        const options = {
            ...userOptions,
            headers: {
                ...defaultHeaders,
                ...(userOptions.headers || {}),
            },
        };

        try {
            const response = await fetch(url, options);
            // console.log('error', response);
            if (!response.ok && response.status === 401) {
                const errorData = await response.json();
                const redirectErrors = ['Forbidden', 'InvalidCredential', 'IncompleteRegistration', 'Unauthenticated', 'Unauthenticated.', 'Invalid token', 'Unauthorized'];
                const errors = ['RegistrationFailed'];
                // console.log('errorData', errorData);
                if (redirectErrors.includes(errorData.message)) {
                    StorageService.clear();
                    CookieService.clear();

                    window.location.href = '/auth/login';
                    throw 'You are not authenticated. Redirecting to login page...';
                } else if (errors.includes(errorData.message)) {
                    // console.log('errors.includes(errorData.error)', errors.includes(errorData.error));
                    // StorageService.clear()
                    // CookieService.clear()
                    // window.location.href = '/'
                    throw errorData;
                } else {
                    const reCallInterception = ['TokenExpired'];

                    if (reCallInterception.includes(errorData.message)) {
                        return ApiInterceptionFetch(url, userOptions);
                    }
                    throw errorData;
                }
            }

            return response;
        } catch (error) {
            // console.log('error', error);
            throw error;
        }
    } catch (error) {
        // console.log('error', error);
        throw error;
    }
};
